// tslint:disable
export enum CampaignType {
    /**
     * @description UNKNOWN
     */
    UNKN = 10001,
    /**
     * @description MULTI MEDIA
     */
    MULMED = 10002,
    /**
     * @description ADHERENCE
     */
    ADHER = 10003,
    /**
     * @description SHARE OF VOICE
     */
    SOV = 10004,
    /**
     * @description Enterprise Database Fulfillment
     */
    EDBF = 10006,
}
